import axios from "axios";
import config from "../config/index";
import { store } from "../store";
import ApiService from "./api-service";

const GeneralService = {
  async getAllPlans({ moduleName } = {}) {
    const { loginReducer } = store.getState();
    const { token } = loginReducer;

    const params = new URLSearchParams();
    if (moduleName) {
      params.set("moduleName", moduleName);
    }

    const query = params.toString() ? `?${params.toString()}` : "";

    const { data } = await axios({
      method: "get",
      url: `${config.apiUrl}/plans${query}`,
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    return data;
  },
  async getAllCurrencies() {
    const body = {
      query: `
      query {
        rates {
          code
          rate
        }
      }
      `,
    };

    const data = await ApiService.baseEndpoint().post("/", body);
    return data?.rates || [];
  },
};

export default GeneralService;
